module.exports = __webpack_public_path__ + "static/media/satellite.553963d1.svg";